import { render, staticRenderFns } from "./ScratchAllWorks.vue?vue&type=template&id=565a6f8d&scoped=true&"
import script from "./ScratchAllWorks.vue?vue&type=script&lang=js&"
export * from "./ScratchAllWorks.vue?vue&type=script&lang=js&"
import style0 from "./ScratchAllWorks.vue?vue&type=style&index=0&id=565a6f8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a6f8d",
  null
  
)

export default component.exports